export default __webpack_public_path__ + "static/media/laceration.187e390f.svg";